import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import CloseIcon from '@material-ui/icons/Close'
import React from 'react'
import { useBulkAddBarStyles } from './bulkAddBarStyles'

export interface BulkAddBarRightSectionProps {
    resetBulkAddElements: () => void
    isBetaWorkspaceToggleEnabled?: boolean
}

const BulkAddBarRightSection = ({
    resetBulkAddElements,
    isBetaWorkspaceToggleEnabled,
}: BulkAddBarRightSectionProps) => {
    const classes = useBulkAddBarStyles({ isBetaWorkspaceToggleEnabled })

    return (
        <GridItem className={classes.rightSideContents}>
            <GridContainer spacing={2} alignItems="center">
                <GridItem className={classes.elementTypeItems}>
                    <CloseIcon
                        onClick={resetBulkAddElements}
                        className={classes.closeIcon}
                        data-testid={`clearBulkAddBtnId`}
                    />
                </GridItem>
            </GridContainer>
        </GridItem>
    )
}

export default BulkAddBarRightSection
